<template>
  <el-container class="pages-common pre-tax-index">
    <leftNav />
    <el-main
      class="main-body"
      v-loading="loading"
      element-loading-text="导入中,请稍候"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(238, 238, 238, 0.9)"
    >
      <div class="page-header">
        <div class="title">应扣管理</div>
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline"
          style="display: inline-block"
        >
          <el-form-item label="姓名">
            <el-input
              v-model="formInline.name"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="工号">
            <el-input
              v-model="formInline.empNo"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input
              v-model="formInline.IDCord"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="扣款项目">
            <el-input
              v-model="formInline.projectName"
              placeholder="请输入"
              clearable
            ></el-input>
            <!-- <el-select
              clearable
              v-model="formInline.projectName"
              multiple
              :collapse-tags="true"
            >
              <el-option label="项目名称1" value="项目名称1"></el-option>
              <el-option label="项目名称2" value="项目名称2"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="扣款出处">
            <el-select clearable v-model="formInline.source">
              <el-option label="工资" value="工资"></el-option>
              <el-option label="佣金" value="佣金"></el-option>
              <el-option label="合作费" value="合作费"></el-option>
              <el-option label="均可" value="均可"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="formInline.remark"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="应扣月份">
            <el-date-picker
              v-model="formInline.month"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="dateChange"
              format="yyyy-MM"
              value-format="yyyy-MM"
              :unlink-panels="true"
            >
            </el-date-picker>
            <!-- <el-select
              clearable
              v-model="formInline.month"
              multiple
              :collapse-tags="true"
            >
              <el-option label="11月" value="11月"></el-option>
              <el-option label="12月" value="12月"></el-option>
              <el-option label="01月" value="01月"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="onSubmit"
              >查询</el-button
            >
            <el-button type="warning" size="small" @click="onReset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <div>
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="myHeaders"
            :on-progress="uploadProgress"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :file-list="fileList"
            :show-file-list="false"
            accept=".xls,.xlsx"
          >
            <el-button size="small" type="primary">导入应扣</el-button>
          </el-upload>
          <el-button size="small" type="success" @click="downModel"
            >下载应扣模板表</el-button
          >
          <el-button size="small" type="info" @click="exportExcels"
            >导出记录</el-button
          >
        </div>
        <!-- <el-button class="upload" size="small" type="success">上传类型表</el-button> -->
        <!-- <el-upload class="upload-demo" :action="actionUrl" :on-success='uploadSuccess' :on-error="uploadError" :file-list="fileList"

 :show-file-list="false" accept=".xls,.xlsx">

<el-button size="small" type="success">上传类型表</el-button>

</el-upload> -->
      </div>
      <div class="page-main">
        <el-table :data="tableData" border stripe size="small" max-height="500">
          <el-table-column label="导入时间" width="150" align="center">
            <template slot-scope="scope">
              {{ scope.row.createTime | FormatDate("YYYY/mm/dd HH:MM:SS") }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createEmpName"
            label="导入人员"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="chargeMonth" label="应扣月份" align="center">
          </el-table-column>
          <el-table-column prop="chargeMoney" label="应扣金额" align="center">
          </el-table-column>
          <el-table-column
            prop="empName"
            label="姓名"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="empNo" label="工号" align="center">
          </el-table-column>
          <el-table-column
            prop="idCard"
            label="身份证号码"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column prop="dept" label="组别" align="center">
          </el-table-column>
          <el-table-column prop="chargeItem" label="扣款项目" align="center">
          </el-table-column>
          <el-table-column prop="chargeFrom" label="扣款出处" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import leftNav from "../components/nav.vue";
import rootUrl from "../utils/api";
import {
  indexPagers,
  indexdownModel,
  getchargeItem,
  indexexportExcels,
  validate,
} from "../api/index";
export default {
  components: {
    leftNav,
  },
  data() {
    return {
      formInline: {},
      currentPage: 1,
      total: 40,
      pageSize: 20,
      tableData: [],
      fileList: [],
      upfileUrl: "",
      uploadUrl: rootUrl + "/should-charge/upload",
      chargeItemPage: 1,
      chargeItemSize: 10,
      month: "",
      startTime: "",
      endTime: "",
      myHeaders: {
        token: this.$store.state.loginToken,
      },
      loading: false,
    };
  },
  mounted() {
    document.title = "应扣管理";
    // getchargeItem({current:this.chargeItemPage,size:this.chargeItemSize}).then(res=>{
    // 	console.log(res);
    // }).catch(res=>{
    // 	console.log(res);
    // });
    this.queryList();
    // console.log(this.$store.state.loginToken);
  },
  methods: {
    queryList() {
      let data = {
        begin: this.startTime, //查询开始时间
        end: this.endTime, //查询结束时间
        chargeFrom: this.formInline.source, //扣款出处
        chargeItem: this.formInline.projectName, //扣款项目
        current: this.currentPage, //当前页
        size: this.pageSize, //每页数量
        empName: this.formInline.name, //姓名
        empNo: this.formInline.empNo, //工号
        idCard: this.formInline.IDCord, //身份证号码
        remark: this.formInline.remark, //备注
      };
      indexPagers(data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.rows;
            console.log(this.tableData);
            this.total = res.data.total;
          } else {
            this.showMessage("error", res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dateChange() {
      if (this.formInline.month == null) {
        this.startTime = "";
        this.endTime = "";
      } else {
        this.startTime = this.formInline.month[0];
        this.endTime = this.formInline.month[1];
      }
    },
    onSubmit() {
      //   console.log("onSubmit");
      //   console.log(this.formInline);
      this.currentPage = 1;
      this.queryList();
    },
    onReset() {
      console.log("onReset");
      this.formInline = {};
      this.currentPage = 1;
      this.startTime = "";
      this.endTime = "";
      this.queryList();
    },
    uploadProgress(response, file, fileList) {
      this.loading = true;
    },
    uploadSuccess(response, file, fileList) {
      //   console.log(response);
      //   console.log(file);
      if (response.code == 200) {
        this.showMessage("success", response.message);
      } else {
        this.showMessage("error", response.message);
      }
      this.loading = false;
      this.currentPage = 1;
      this.queryList();
    },
    uploadError(err, file, fileList) {
      console.log(err);
      console.log(file);
      this.loading = false;
      this.currentPage = 1;
      this.queryList();
    },
    //下载模板
    downModel() {
      validate()
        .then((res) => {
          // console.log(res);
          if (res.success) {
            this.xhr = new XMLHttpRequest();
            this.xhr.open(
              "GET",
              rootUrl + "/should-charge/downloadChargeTemplate",
              true
            );
            this.xhr.responseType = "blob";
            var vmThis = this;
            this.xhr.onload = () => {
              if (this.xhr.status === 200) {
                if (
                  this.xhr.response &&
                  this.xhr.response.size &&
                  this.xhr.response.size > 0
                ) {
                  let file = this.xhr.response;
                  let fileName = "template.xlsx";
                  if ("msSaveOrOpenBlob" in navigator) {
                    window.navigator.msSaveOrOpenBlob(file, fileName);
                  } else {
                    let fileUrl = window.URL.createObjectURL(file);
                    let a = document.createElement("a");
                    a.download = fileName;
                    a.href = fileUrl;
                    document.getElementsByTagName("body")[0].appendChild(a);
                    a.click();
                    a.parentNode.removeChild(a);
                    window.URL.revokeObjectURL(fileUrl);
                  }
                }
              } else {
                //
              }
            };
            this.xhr.setRequestHeader("token", this.$store.state.loginToken);
            this.xhr.send();
          } else {
            this.showMessage("error", res.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    //导出
    exportExcels() {
      let data = {
        begin: this.startTime, //查询开始时间
        end: this.endTime, //查询结束时间
        chargeFrom: this.formInline.source ? this.formInline.source : "", //扣款出处
        chargeItem: this.formInline.projectName
          ? this.formInline.projectName
          : "", //扣款项目
        empName: this.formInline.name ? this.formInline.name : "", //姓名
        empNo: this.formInline.empNo ? this.formInline.empNo : "", //工号
        idCard: this.formInline.IDCord ? this.formInline.IDCord : "", //身份证号码
        remark: this.formInline.remark ? this.formInline.remark : "", //备注
      };

      this.xhr = new XMLHttpRequest();
      this.xhr.open(
        "GET",
        rootUrl +
          "/should-charge/export" +
          `?begin=${data.begin}&end=${data.end}&chargeFrom=${data.chargeFrom}&chargeItem=${data.chargeItem}&empName=${data.empName}&empNo=${data.empNo}&idCard=${data.idCard}&remark=${data.remark}`,
        true
      );
      this.xhr.responseType = "blob";
      var vmThis = this;
      this.xhr.onload = () => {
        if (this.xhr.status === 200) {
          if (
            this.xhr.response &&
            this.xhr.response.size &&
            this.xhr.response.size > 0
          ) {
            let file = this.xhr.response;
            let fileName = "应扣管理导出.xlsx";
            if ("msSaveOrOpenBlob" in navigator) {
              window.navigator.msSaveOrOpenBlob(file, fileName);
            } else {
              let fileUrl = window.URL.createObjectURL(file);
              let a = document.createElement("a");
              a.download = fileName;
              a.href = fileUrl;
              document.getElementsByTagName("body")[0].appendChild(a);
              a.click();
              a.parentNode.removeChild(a);
              window.URL.revokeObjectURL(fileUrl);
            }
          }
        } else {
          //
        }
      };
      this.xhr.setRequestHeader("token", this.$store.state.loginToken);
      this.xhr.send();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.queryList();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryList();
      console.log(`当前页: ${val}`);
    },
    showMessage(type, msg) {
      this.$message({
        message: msg,
        type: type,
        duration: 5000,
        center: true,
      });
    },
  },
};
</script>

<style>
.el-date-editor .el-range-separator {
  padding: 0 !important;
  color: #eee;
}
</style>
